import { render, staticRenderFns } from "./CategoryForm.vue?vue&type=template&id=7ebd9417"
import script from "./CategoryForm.vue?vue&type=script&lang=js"
export * from "./CategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ebd9417')) {
      api.createRecord('7ebd9417', component.options)
    } else {
      api.reload('7ebd9417', component.options)
    }
    module.hot.accept("./CategoryForm.vue?vue&type=template&id=7ebd9417", function () {
      api.rerender('7ebd9417', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/process/CategoryForm.vue"
export default component.exports